
import { Component, Prop, Vue } from 'vue-property-decorator';
import ColorModuleSearch from '@/components/global/color-module/ColorModuleSearch.vue';
import OptionalColorModuleFilters from '@/components/global/color-module/OptionalColorModuleFilters.vue';

@Component({
    name: 'ColorModuleHeader',
    components: {
        ColorModuleSearch,
        OptionalColorModuleFilters,
    },
})
export default class ColorModuleHeader extends Vue {
    @Prop({ required: false, default: false }) private activeTab!: string;
    @Prop({ required: true }) private filters!: any;
    @Prop({ required: true }) private filtersActive!: boolean;
    @Prop({ required: true }) private requestFiltersActive!: boolean;
    @Prop({ required: true }) private searchQuery!: string;
    @Prop({ required: false, default: false }) private showLatestColors!: boolean;

    private setFilters(active: boolean) {
        this.$emit('setFiltersActiveState', active);
    }

    private clearFilters() {
        this.$emit('clearFilters');
    }

    private requestTabClick() {
        const activeTab = this.activeTab === 'color-request' ? 'color-search' : 'color-request';
        this.$emit('changeActiveTab', activeTab);
    }

    private get filterActiveState() {
        if (this.activeTab === 'color-request') {
            return this.requestFiltersActive;
        }

        return this.filtersActive;
    }

    private get tabSwitchText() {
        if (this.activeTab === 'color-request') {
            return this.$t('Color Search');
        }

        return this.$t('Color Request');
    }
}
